import React, { useState } from 'react';
import {
  TextField,
  Button,
  Box,
  FormControl,
  FormHelperText,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import OnboardingContainer from '../Component/OnboardingContainer';
import { ScreenBackV2WithTitle } from '../../Components/ScreenBackV2';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const CreatePassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const phone_number = location?.state?.phone_number || null;
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const handleToggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!phone_number) {
      return toast.error('Phone number is required');
    }

    if (!password) {
      newErrors.password = 'Password is required';
    } else if (password.length < 8) {
      newErrors.password = 'Password must be at least 8 characters';
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = 'Confirm password is required';
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }
    const payload = {
      phone_number: phone_number,
      password: password,
      confirm_password: confirmPassword,
    };
    navigate('/UserOnboarding', {
      state: { data: payload },
    });
  };

  return (
    <OnboardingContainer>
      <ScreenBackV2WithTitle title={'Create Password'} />
      <form onSubmit={handleSubmit}>
        <FormControl
          sx={{ width: '80%' }}
          margin='normal'
          error={!!errors.password}
        >
          <TextField
            className='darkBackground'
            fullWidth
            id='password'
            type={showPassword ? 'text' : 'password'}
            value={password}
            color='secondary'
            onChange={(e) => setPassword(e.target.value)}
            label='New Password'
            InputProps={{
              endAdornment: password?.length > 0 && (
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle password visibility'
                    onClick={handleTogglePasswordVisibility}
                    edge='end'
                  >
                    {showPassword ? (
                      <VisibilityOff sx={{ color: 'white' }} />
                    ) : (
                      <Visibility sx={{ color: 'white' }} />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            required
          />
          {errors.password && (
            <FormHelperText>{errors.password}</FormHelperText>
          )}
        </FormControl>
        <FormControl
          fullWidth
          margin='normal'
          error={!!errors.confirmPassword}
          sx={{ width: '80%' }}
        >
          <TextField
            className='darkBackground'
            id='confirm-password'
            type={showConfirmPassword ? 'text' : 'password'}
            value={confirmPassword}
            color='secondary'
            onChange={(e) => setConfirmPassword(e.target.value)}
            label='Confirm Password'
            InputProps={{
              endAdornment: confirmPassword?.length > 0 && (
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle password visibility'
                    onClick={handleToggleConfirmPasswordVisibility}
                    edge='end'
                  >
                    {showConfirmPassword ? (
                      <VisibilityOff sx={{ color: 'white' }} />
                    ) : (
                      <Visibility sx={{ color: 'white' }} />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            required
          />
          {errors.confirmPassword && (
            <FormHelperText>{errors.confirmPassword}</FormHelperText>
          )}
        </FormControl>
        <Box sx={{ mt: 2, width: '80%' }}>
          <Button
            type='submit'
            variant='contained'
            color='primary'
            fullWidth
          >
            Continue
          </Button>
        </Box>
      </form>
    </OnboardingContainer>
  );
};

export default CreatePassword;
